import { Position } from '@src/main/modules/parameters/domain/fleet-positions/position.interface';
import { PositionRepository } from '@src/main/modules/parameters/domain/fleet-positions/position.repository';
import { CreateUpdatePositionRequest } from '@src/main/modules/parameters/infrastructure/dto/createUpdatePositionRequest';
import {
  PositionEntity,
  toPosition,
} from '@src/main/modules/parameters/infrastructure/entity/position.entity';
import { api, TokenProvider } from '@src/main/shared/infrastructure/entity/axios';

const path = '/positions';

export const createPositionHttpRepository = (tokenProvider: TokenProvider): PositionRepository =>
  new PositionHttpRepository(tokenProvider);

class PositionHttpRepository implements PositionRepository {
  private readonly tokenProvider: TokenProvider;

  constructor(tokenProvider: TokenProvider) {
    this.tokenProvider = tokenProvider;
  }

  private async getAuthToken(): Promise<string> {
    const token = await this.tokenProvider.getToken();
    if (!token) throw new Error('Authentication token is missing');
    return token;
  }

  async findAll(): Promise<Position[]> {
    const token = await this.getAuthToken();
    const response = await api.get<PositionEntity[]>(`${path}/all`, token);
    return response.map(toPosition);
  }

  async findById(id: string): Promise<Position> {
    const token = await this.getAuthToken();
    const response = await api.get<PositionEntity>(`${path}/${id}`, token);
    return toPosition(response);
  }

  async create(position: CreateUpdatePositionRequest): Promise<Position> {
    const token = await this.getAuthToken();
    const response = await api.post<PositionEntity>(path, token, position);
    return toPosition(response);
  }

  async update(id: string, position: CreateUpdatePositionRequest): Promise<Position> {
    const token = await this.getAuthToken();
    const response = await api.put<PositionEntity>(`${path}/${id}`, token, position);
    return toPosition(response);
  }

  async delete(id: string): Promise<void> {
    const token = await this.getAuthToken();
    await api.delete(`${path}/${id}`, token);
  }
}
